import {Component, OnInit,} from '@angular/core';
import {FormBuilder, FormGroup,} from '@angular/forms';
import {HttpClient,} from '@angular/common/http';
import {LoginUserVO,} from '@models/system-vo/login-user-vo';
import {MessageLevel,} from '@models/system-vo/message-level';
import {FileUtil,
        Logger,
        LoginInfoService,
        MessageProvider,
        MessageStackService,
        ScreenMessageHandler,
        SmsMenuPage,
        SmsErrorPage,
        StringUtil,
        SystemConstant,
        ValidationService,
        WindowService,} from '@services/index';
import {SMS004BarcodeLinkOutVO,} from '@pages/sms004-barcode-link/sms004-barcode-link-out-vo';
import {SMS004BarcodeLinkDispVO,} from '@pages/sms004-barcode-link/sms004-barcode-link-disp-vo';
import * as Const_SMS004 from '@pages/sms004-barcode-link/sms004-barcode-link-const';
import {SMS008KingakuInfoInVO,} from '@pages/sms008-kingaku-info/sms008-kingaku-info-in-vo';
import {Title,} from '@angular/platform-browser';

@Component({
  selector: 'app-sms004-barcode-link',
  templateUrl: './sms004-barcode-link.html',
  styleUrls: ['./sms004-barcode-link.scss',],
})

/*****************************************************/
/* 処　理：SMS004 コンビニ収納サービス 画面
/*
/* 概　要：バーコード用リンク 処理
/*
/* 更新日：2026/02/03 KOJIMA 00067_家賃債務保証業者登録規程の改定による文言追加
/*****************************************************/
export class SMS004BarcodeLink implements OnInit {
  smsForm!: FormGroup;                     // 画面フォーム
  loginUserVO!: LoginUserVO;               // セッション情報
  sms004ApiRetVO!: SMS004BarcodeLinkOutVO; // API返却情報
  dispId!: string;                         // ログ表示用ID
  lngType!: string;                        //  言語区分

  // コンテンツエリア：style.width 設定用
  windowsWidth = this.constant.DEFAULT_DEVICE_SCREEN_WIDTH + 'px';

  // ボタン操作可否
  isEnableBtnBarcode = true;
  isEnableBtnDetail = true;
  isEnableBtnMenu = true;

  // 画面項目（ラベル入れ替え用）
  public lblName!: string;
  public lblMessage01!: string;
  public lblMessage02!: string
  public lblMessage03!: string;
  public lblMessage04!: string;
  public lblMessage05!: string;
  public lblMessage06!: string;
  public lblMessage07!: string;
  public lblBtnBarcode!: string;
  public lblBtnDetail!: string;
  public lblBtnMenu!: string;
  public lblScreenName!: string;

  // 明細表示用クラス
  initVo: SMS004BarcodeLinkDispVO[] = [];

  /**
   * デフォルトコンストラクタ
   */
  constructor(
    private constant: SystemConstant,
    private fb: FormBuilder,
    private httpClient: HttpClient,
    private logger: Logger,
    private messageProvider: MessageProvider,
    private windowService: WindowService,
    private titleService: Title,
    private screenMessage: ScreenMessageHandler,
    private smsMenuPage: SmsMenuPage,
    private smsErrPage: SmsErrorPage,
    public fileUtil: FileUtil,
    public loginInfoService: LoginInfoService,
    public stringUtil: StringUtil,
    public validationService: ValidationService
  ) {
    const connVo: LoginUserVO = this.loginInfoService.getLoginUserInfo();
    if (connVo && connVo.hashId != null && !this.stringUtil.isEmpty(connVo.hashId)
        && connVo.accessToken  != null && !this.stringUtil.isEmpty(connVo.accessToken)
        && connVo.refreshToken != null && !this.stringUtil.isEmpty(connVo.refreshToken)) {

      // ログイン情報を取得
      this.loginUserVO = connVo;

      // ログ表示用ID・言語区分セット
      this.dispId = this.loginUserVO.keiyakuInfoId.toString();
      this.lngType = this.loginUserVO.languageType;

    } else {

      // エラーログ出力
      this.logger.error('SMS00401M005E');

      // ログイン情報が取得出来ない場合、エラー画面へ遷移（予期せぬエラー）
      const messageStack = new MessageStackService(MessageLevel.ERROR);
      messageStack.add({messageId: 'SMS99901M013E',});
      this.smsErrPage.transition(messageStack, '', '', constant.DEFAULT_LANGUAGE_TYPE);
      return;
    }
  }

  /**
   * 初期処理(ngOnInit).
   */
  ngOnInit(): void {

    // 画面オブジェクト
    this.smsForm = this.fb.group({
      rdoYatinYmKbn: ['',],
    });

    // 初期表示
    this.formInit();
  }

  /* **************************************************************
   * 初期表示
   * **************************************************************/
  formInit(): void {
    try {
      // ログ出力
      this.logger.info('SMS00401M001I', this.dispId, Const_SMS004.INIT_NAME);

      // 初期表示API処理
      this.getInitData(Const_SMS004.API_INIT_PATH, Const_SMS004.INIT_NAME);

      // デバイスの横幅がデフォルト値未満の場合、横幅を調整する
      if (this.constant.DEFAULT_DEVICE_SCREEN_WIDTH > window.innerWidth) {
        this.logger.debug('■ content-area style.width:' + window.innerWidth);
        this.windowsWidth = window.innerWidth + 'px';
      }

      // ログ出力
      this.logger.info('SMS00401M002I', this.dispId, Const_SMS004.INIT_NAME);

    } catch (ex) {
      this.logger.error('SMS00401M001E', this.dispId, Const_SMS004.INIT_NAME);
      this.commonException(ex);
    }
  }

  /**
   * 初期表示API処理
   * @param {string} path パスAPI
   * @param {string} btnName ボタン名
   */
  private getInitData(path: string, btnName: string): void {

    this.logger.debug(this.dispId + ' ■ 04 start-- getInitData');

    // APIパラメータ設定
    const apiVo = {
      keiyakuInfoId: this.loginUserVO.keiyakuInfoId,
      shouninNo: this.loginUserVO.shouninNo,
    }

    // ログ出力（API入力情報）
    this.logger.debug(this.dispId + ' ■ 04 URL：[' + path + ']');
    this.logger.debug(this.dispId + ' ■ 04 ApiIn   keiyakuInfoId：' + apiVo.keiyakuInfoId);
    this.logger.debug(this.dispId + ' ■ 04 ApiIn   shouninNo    ：' + apiVo.shouninNo);

    // 初期表示API
    this.logger.info('SMS00401M003I', this.dispId, btnName);
    this.httpClient.post<SMS004BarcodeLinkOutVO>(path, apiVo).subscribe({
      next: (resp) => {
        this.logger.info('SMS00401M004I', this.dispId, btnName);
        if (resp != null) {
          // 初期表示API 返却情報設定
          this.getInitApiReturnInfo(resp);

        } else {
          // エラー画面へ遷移（予期せぬエラー）
          this.logger.error('SMS00401M003E', this.dispId);
          const messageStack = new MessageStackService(MessageLevel.ERROR);
          messageStack.add({messageId: 'SMS99901M013E',});
          this.transitErrPage(messageStack);
        }
        return;
      },
      error: (err: MessageStackService | Error) => {
        // エラーログ
        this.logger.error('SMS00401M004E', this.dispId);

        // Errorの場合
        if (err instanceof Error) {
          // 共通例外処理
          this.commonException(err);
          return;
        }
        // MessageStackの場合
        if (err instanceof MessageStackService && err.messages.length > 0) {
          const messageStack: MessageStackService = new MessageStackService(MessageLevel.ERROR);
          for (const messageError of err.messages) {
            this.logger.debug(this.dispId + ' ■ 04 messageId ：' + messageError.messageId);
            this.logger.error(messageError.messageId);
            messageStack.add({messageId: messageError.messageId,});
          }
          // エラー画面へ遷移
          this.transitErrPage(messageStack);
          return;
        }
      },
    });
  }

  /**
   * 初期表示API 返却情報設定
   *
   * @param {SMS004BarcodeLinkOutVO} resp API返却情報
   * @returns -
   */
  getInitApiReturnInfo(resp: SMS004BarcodeLinkOutVO): void {

    this.logger.debug(this.dispId + ' ■ 04 start-- getInitApiReturnInfo');

    // 支払明細
    const retVOList = resp['siharaiVO'];

    // {0}年{1}月
    const ym = (this.messageProvider.getMessageString({messageId: 'SMS004' + this.lngType + 'M009F',},  false) || '');
    // {1} 円
    const yen = (this.messageProvider.getMessageString({messageId: 'SMS004' + this.lngType + 'M010F',},  false) || '');

    // 明細情報 設定
    for (const retVO of retVOList) {

      // ログ出力（API出力情報）
      this.logger.debug(this.dispId + ' ■ 04 ApiOut  yatinYm    ：' + retVO.yatinYm);
      this.logger.debug(this.dispId + ' ■ 04 ApiOut  seikyuGaku ：' + retVO.seikyuGaku);

      const yy = retVO.yatinYm.substring(0, 4);
      const mm = retVO.yatinYm.substring(4, 6);
      this.initVo.push({id: retVO.yatinYm + ':' + retVO.seikyuGaku
                      , yatinYm: ym.replace('{1}', yy).replace('{2}', mm)
                      , seikyuGaku: yen.replace('{1}', retVO.seikyuGaku),});
    }

    // 画面文言（言語区分により変換）
    // {0}　{1} 様
    this.lblName = (this.messageProvider.getMessageString({messageId: 'SMS004' + this.lngType + 'M001F',},  false) || '').replace('{1}', resp['sei']).replace('{2}', resp['mei']);
    // オリコフォレントインシュアでございます。
    this.lblMessage01 = this.messageProvider.getMessageString({messageId: 'SMS004' + this.lngType + 'M002F',},  false) || '';
    // お支払いになる家賃月を選択し送信ボタンを押してください。
    this.lblMessage02 = this.messageProvider.getMessageString({messageId: 'SMS004' + this.lngType + 'M003F',},  false) || '';
    // 支払用バーコードが表示されます。
    this.lblMessage03 = this.messageProvider.getMessageString({messageId: 'SMS004' + this.lngType + 'M004F',},  false) || '';
    // ※30万円を超過する支払額はバーコードでの支払いはできません。
    this.lblMessage04 = this.messageProvider.getMessageString({messageId: 'SMS004' + this.lngType + 'M005F',},  false) || '';
    // コンビニ払いバーコード発行
    this.lblBtnBarcode = this.messageProvider.getMessageString({messageId: 'SMS004' + this.lngType + 'M006F',},  false) || '';
    // 詳細金額表示へ
    this.lblBtnDetail = this.messageProvider.getMessageString({messageId: 'SMS004' + this.lngType + 'M007F',},  false) || '';
    // メニューへ戻る
    this.lblBtnMenu = this.messageProvider.getMessageString({messageId: 'SMS004' + this.lngType + 'M008F',},  false) || '';
    // 求償権の行使に関する相談又は苦情に関するご連絡先
    this.lblMessage05 = this.messageProvider.getMessageString({messageId: 'SMS004' + this.lngType + 'M011F',}, false) || '';
    // 株式会社オリコフォレントインシュア　お客様相談窓口 TEL：0570-030-733
    this.lblMessage06 = this.messageProvider.getMessageString({messageId: 'SMS004' + this.lngType + 'M012F',}, false) || '';
    // ※通話内容はお客様対応品質向上のため録音させていただいております。
    this.lblMessage07 = this.messageProvider.getMessageString({messageId: 'SMS004' + this.lngType + 'M013F',}, false) || '';

    // 家賃年月のデフォルト値設定
    this.smsForm.get('rdoYatinYmKbn')?.setValue(this.initVo[0].id);
    this.logger.debug(this.dispId + ' ■ 04 default rdoYatinYmKbn ：' + this.smsForm.get('rdoYatinYmKbn')?.value);

    // ブラウザ・ヘッダータイトル
    const screenName = this.messageProvider.getMessageString({messageId: 'SMS004' + this.lngType + 'M001T',}) || '';
    const companyName = this.messageProvider.getMessageString({messageId: 'SMS999' + this.lngType + 'M001T',}) || '';
    this.titleService.setTitle(screenName + ' | ' + companyName);
    document.getElementById('lblScreenTitle')!.innerText = screenName;

    this.logger.debug(this.dispId + ' ■ 04 end---- getInitApiReturnInfo');
    return;
  }


  /* **************************************************************
   * 詳細金額表示へボタン押下
   * **************************************************************/
  detailClick(): void {
    try {
      // ログ出力
      this.logger.info('SMS00401M005I', this.dispId, Const_SMS004.BTN_DETAIL_NAME);

      // スナックバーを閉じる
      this.screenMessage.closeMessage();

      // 画面入力チェック
      if (!this.inputCheck()) {
        return;
      }

      // 画面遷移
      this.nextPage('SMS008', '');

    } catch (ex) {
      this.logger.error('SMS00401M002E', this.dispId, Const_SMS004.BTN_DETAIL_NAME);
      this.commonException(ex);
    }
  }

  /**
   * 画面入力チェック
   * @returns true/false
   */
  inputCheck(): boolean {
    let isRet = true;
    const messageStack = new MessageStackService(MessageLevel.ERROR);

    this.logger.debug(this.dispId + ' ■ 04 入力チェック開始');

    // ------------------------------------------
    // 必須チェック
    // ------------------------------------------
    // 家賃年月
    if (this.smsForm.get('rdoYatinYmKbn')?.value === '') {
      this.logger.debug('■ 04 家賃年月：必須NG');
      isRet = false;
    }

    // ------------------------------------------
    // 入力チェック結果判定
    // ------------------------------------------
    if (isRet) {
      // 入力チェックOK
      this.logger.info('SMS99901M004I', this.dispId);
    } else {
      // 入力チェックNG
      this.logger.info('SMS99901M005I', this.dispId);
      messageStack.add({messageId: 'SMS999' + this.lngType + 'M011E',});
      this.screenMessage.showMessage(messageStack);
    }

    this.logger.debug(this.dispId + ' ■ 04 入力チェック終了');

    return isRet;
  }

  /* **************************************************************
   * バーコード発行ボタン押下
   * **************************************************************/
  barcodeClick(): void {
    try {
      // ログ出力
      this.logger.info('SMS00401M005I', this.dispId, Const_SMS004.BTN_BARCODE_NAME);

      // スナックバーを閉じる
      this.screenMessage.closeMessage();

      // 画面入力チェック(バーコード)
      if (!this.inputCheck_Barcode()) {
        return;
      }

      // 画面項目制御
      this.enabledChange(false);

      // バーコードURL生成API 呼出
      this.doBarcodeMake(Const_SMS004.API_BARCODE_PATH, Const_SMS004.BARCODE_NAME);

    } catch (ex) {
      this.logger.error('SMS00401M002E', this.dispId, Const_SMS004.BTN_BARCODE_NAME);
      this.commonException(ex);
    }
  }

  /**
   * 画面入力チェック(バーコード)
   * @returns true/false
   */
  inputCheck_Barcode(): boolean {
    let isRet = true;
    const messageStack = new MessageStackService(MessageLevel.ERROR);

    this.logger.debug(this.dispId + ' ■ 04 入力チェック開始');

    // ------------------------------------------
    // 必須チェック
    // ------------------------------------------
    // 家賃年月
    if (this.smsForm.get('rdoYatinYmKbn')?.value === '') {
      this.logger.debug('■ 04 家賃年月：必須NG');
      isRet = false;
    }

    // ラジオボタンの家賃年月を分割
    const yatinYm = this.smsForm.get('rdoYatinYmKbn')?.value.split(':');
    const seikyuKingaku  = yatinYm[1].replaceAll(',', '');

    this.logger.debug(this.dispId + ' ■ 請求金額:' + seikyuKingaku);
    this.logger.debug(this.dispId + ' ■ 上限金額:' + Const_SMS004.LIMIT_SEIKYU_KINGAKU);

    // 請求金額の上限チェック
    if (seikyuKingaku > Const_SMS004.LIMIT_SEIKYU_KINGAKU) {
      this.logger.debug('■ 04 請求金額：30万円まで NG');
      isRet = false;
    }

    // ------------------------------------------
    // 入力チェック結果判定
    // ------------------------------------------
    if (isRet) {
      // 入力チェックOK
      this.logger.info('SMS99901M004I', this.dispId);
    } else {
      // 入力チェックNG
      this.logger.info('SMS99901M005I', this.dispId);
      messageStack.add({messageId: 'SMS999' + this.lngType + 'M011E',});
      this.screenMessage.showMessage(messageStack);
    }

    this.logger.debug(this.dispId + ' ■ 04 入力チェック終了');

    return isRet;
  }

  /**
   * バーコードURL生成API処理
   * @param {string} path パスAPI
   * @param {string} btnName ボタン名
   */
  private doBarcodeMake(path: string, btnName: string): void {

    // ログ出力
    this.logger.info('SMS00401M001I', this.dispId, btnName);
    this.logger.debug(this.dispId + ' ■ 04 start-- doBarcodeMakeAPI');

    // ラジオボタンの家賃年月を分割
    const yatinYm = this.smsForm.get('rdoYatinYmKbn')?.value.split(':');

    // APIパラメータ設定
    const apiVo = {
      keiyakuInfoId: this.loginUserVO.keiyakuInfoId,
      shouninNo: this.loginUserVO.shouninNo,
      yatinYm: yatinYm[0],
      seikyuKingaku: yatinYm[1].replaceAll(',', ''),
    }

    // ログ出力（API入力情報）
    this.logger.debug(this.dispId + ' ■ 04 URL：[' + path + ']');
    this.logger.debug(this.dispId + ' ■ 04 ApiIn   keiyakuInfoId ：' + apiVo.keiyakuInfoId);
    this.logger.debug(this.dispId + ' ■ 04 ApiIn   shouninNo     ：' + apiVo.shouninNo);
    this.logger.debug(this.dispId + ' ■ 04 ApiIn   yatinYm       ：' + apiVo.yatinYm);
    this.logger.debug(this.dispId + ' ■ 04 ApiIn   seikyuKingaku ：' + apiVo.seikyuKingaku);

    // バーコードURL生成API呼び出し
    this.logger.info('SMS00401M003I', this.dispId, btnName);
    this.httpClient.post<SMS004BarcodeLinkOutVO>(path, apiVo).subscribe({
      next: (resp) => {
        this.logger.info('SMS00401M004I', this.dispId, btnName);
        if (resp != null) {

          // ログ出力（API出力情報）
          this.logger.debug(this.dispId + ' ■ 04 ApiOut   barcodeUrl   ：' + resp['barcodeUrl']);

          // 戻り値の生成されたURLで画面遷移
          this.nextPage('mypayment', resp['barcodeUrl']);

        } else {
          // エラー画面へ遷移（予期せぬエラー）
          this.logger.error('SMS00401M003E', this.dispId);
          const messageStack = new MessageStackService(MessageLevel.ERROR);
          messageStack.add({messageId: 'SMS99901M013E',});
          this.transitErrPage(messageStack);
        }
        return;
      },
      error: (err: MessageStackService | Error) => {
        this.logger.error('SMS00401M004E', this.dispId);

        // Errorの場合
        if (err instanceof Error) {
          this.commonException(err);
          return;
        }
        // MessageStackの場合
        if (err instanceof MessageStackService && err.messages.length > 0) {
          const messageStack: MessageStackService = new MessageStackService(MessageLevel.ERROR);
          for (const messageError of err.messages) {
            this.logger.debug(this.dispId + ' ■ 04 messageId ：' + messageError.messageId);
            this.logger.error(messageError.messageId);
            messageStack.add({messageId: messageError.messageId,});
          }
          // エラー画面へ遷移
          this.transitErrPage(messageStack);
          return;
        }
      },
    });
  }

  /**
   * 画面遷移処理
   * @param {string} dispId 画面ID
   * @param {string} url URLパス
   */
  nextPage(dispId: string, url: string): void{

    if ('SMS008' === dispId) {
      this.logger.debug(this.dispId + ' ■ 04 → 08 画面遷移');

      // ラジオボタンの家賃年月を分割
      const yatinYm = this.smsForm.get('rdoYatinYmKbn')?.value.split(':');

      const info008Vo: SMS008KingakuInfoInVO = new SMS008KingakuInfoInVO();
      info008Vo.yatinYm = yatinYm[0];
      this.windowService.transit<SMS008KingakuInfoInVO>('SMS008', info008Vo);

    } else {
      this.logger.debug(this.dispId + ' ■ 外部：マイペイメントへ');

      // マイペイメント画面へ
      window.location.href = url;
    }
  }


  /* **************************************************************
   * メニューへ戻るボタン押下
   * **************************************************************/
  backClick(): void {
    try {
      // ログ出力
      this.logger.info('SMS00401M005I', this.dispId, Const_SMS004.BTN_BACKMENU_NAME);

      // スナックバーを閉じる
      this.screenMessage.closeMessage();

      // SMS001：メインメニュー画面に遷移
      this.smsMenuPage.transition(this.loginUserVO.hashId,
                                  this.loginUserVO.menuNo,
                                  this.loginUserVO.languageType);

    } catch (ex) {
      this.logger.error('SMS00401M002E', this.dispId, Const_SMS004.BTN_BACKMENU_NAME);
      this.commonException(ex);
    }
  }

  /**
   * 共通例外処理
   * @param {Error} err
   */
  private commonException(err?: Error | unknown): void {

    this.logger.debug(this.dispId + ' ■ 04 共通例外処理開始');

    // エラーログ
    if (err instanceof Error) {
      this.logger.errorWithFreeText(SystemConstant.UNEXPECTED_ERROR, err.message, this.dispId);
    } else {
      this.logger.errorWithFreeText(SystemConstant.UNEXPECTED_ERROR, err, this.dispId);
    }

    // エラー画面へ遷移（予期せぬエラー）
    const messageStack = new MessageStackService(MessageLevel.ERROR);
    messageStack.add({messageId: 'SMS99901M013E',});
    this.transitErrPage(messageStack);
  }

  /**
   * エラー画面へ遷移
   * @param {MessageStackService} messageStack
   */
  transitErrPage(messageStack: MessageStackService): void {

    // SMS011：エラー画面に遷移
    this.smsErrPage.transition(messageStack,
                               this.loginUserVO.hashId,
                               this.loginUserVO.menuNo,
                               this.loginUserVO.languageType);
  }

  /**
   * 画面項目の制御
   * @param {boolean} isEnabledFlg
   */
  enabledChange(isEnabledFlg: boolean): void {
    this.isEnableBtnBarcode = isEnabledFlg;
    this.isEnableBtnDetail = isEnabledFlg;
    this.isEnableBtnMenu = isEnabledFlg;
  }

}
